import {useTranslation} from "react-i18next";
import Swal from "sweetalert2";

const useSwal = () => {
  const {t} = useTranslation();

  return {
    confirm: ({confirmFunc = () => {}, cancelFunc = () => {}, title = "", text = ""}) => {
      Swal.fire({
        title: t(title),
        text: t(text) || `${t("Are you sure?")}`,
        icon: "question",
        confirmButtonText: [t("Yes")],
        showCancelButton: true,
        cancelButtonText: [t("No")],
      }).then(answ => {
        if (answ.isConfirmed) {
          confirmFunc();
        } else {
          cancelFunc;
        }
      });
    },
    info: ({confirmFunc = () => {}, text = ""}) => {
      Swal.fire({
        title: t("Information"),
        text: t(text),
        icon: "info",
        confirmButtonText: [t("Yes")],
        showCancelButton: true,
        cancelButtonText: [t("No")],
      }).then(answ => {
        if (answ.isConfirmed) {
          confirmFunc();
        }
      });
    },
    message: ({title = "", text = ""}) => {
      Swal.fire({
        title: t(title),
        text: t(text),
        icon: "info",
        confirmButtonText: [t("Yes")],
        showCancelButton: false,
      });
    },
  };
};

export default useSwal;
